<template>
    <div v-if="typeId > 0">
        <button class="btn btn-light btn-sm" type="button" @click="goToVariations">
            {{ formattedValue }}
        </button>
    </div>
</template>

<script>
import {defineComponent, computed, getCurrentInstance} from 'vue'

export default defineComponent({
    name: "TableCellProductVariations",
    props: {
        item: Object,
        value: Number
    },
    setup(props) {
        const {proxy} = getCurrentInstance()

        const typeId = computed(() => (props.item && props.item.typeId) || 0)
        const formattedValue = computed(() =>
            new Intl.NumberFormat().format(props.value || 0)
        )

        const goToVariations = async () => {
            const {data} = await proxy.$store.dispatch('request/get', {
                url: 'api/Products/getTypesTableNames'
            })
            window.location = `/#/${data[typeId.value]}?productId=${props.item.id}`
        }

        return {typeId, formattedValue, goToVariations}
    }
})
</script>

<style scoped></style>